import { EntityService } from './EntityService';
import { IPPAppProjectFinancial } from '../types';

export class PPAppProjectFinancialService extends EntityService<IPPAppProjectFinancial> {
    constructor() {
        super(`/PPAppProjectFinancials`);
    }

    public update(entityId: number, entity: Partial<IPPAppProjectFinancial>): Promise<void> {
        const entityToPost = entity;
        delete entityToPost.Project;
        return this.axiosPatch(`${this.entityUrl}(${entityId})`, entityToPost);
    }
}